import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AddressLookupForm from "../components/AddressLookupForm";
import AddressSelect from "../components/AddressSelect";
import Button from "../components/Button";
import Container from "../components/Container";
import ErrorMessageBlock from "../components/ErrorMessageBlock";
import Header from "../components/Header";
import { useUserInfo } from "../context/UserInfoContext";
import useRedirectIfNotInLocalStorage from "../hooks/useRedirectIfNotInLocalStorage";
import EN from "../locales/en";
import withContentfulTag from "../utils/withContentfulTag";

const Address = ({ contentful }) => {
  const { showAddressPageError, gasOnlyAddressError, resetAddressStates } =
    useUserInfo();
  const navigate = useNavigate();

  useEffect(() => {
    resetAddressStates();
  }, []);

  useRedirectIfNotInLocalStorage(
    ["firstName", "lastName", "emailAddress"],
    "/"
  );

  const backToHome = () => {
    navigate("/");
  };

  return contentful ? (
    <Container>
      {gasOnlyAddressError ? (
        <>
          <Header title="Something went wrong" />
          <p className="text-center my-6">
            According to the energy industry database we use, the address
            entered has no electricity meter, meaning we can't provide a tariff
            comparison for you. Please contact your energy supplier and ask them
            to update the central industry records associated with your address
            to include an MPAN (meter point administration number).
          </p>
          <Button onClick={backToHome} fullWidth>
            Back to home
          </Button>
        </>
      ) : (
        <>
          {showAddressPageError && <ErrorMessageBlock />}
          <Header title={EN.address.title} subtitle={EN.address.subtitle} />

          <div className="mt-4">
            <AddressLookupForm />
          </div>

          <AddressSelect
            fullTerms={{
              title: contentful?.title,
              body: contentful?.body,
            }}
          />
        </>
      )}
    </Container>
  ) : null;
};

export default withContentfulTag(Address, "switching_terms_of_use");
